import { Box, Typography } from '@mui/material';
import ActiveIcon from 'common/customIcons/active';
import ClosurePendingIcon from 'common/customIcons/closurePending';
import CompletedIcon from 'common/customIcons/completed';
import DispatchedIcon from 'common/customIcons/dispatched';
import DistributedIcon from 'common/customIcons/distributed';
import FreezedIcon from 'common/customIcons/freezed';
import HoldIcon from 'common/customIcons/hold';
import InActiveIcon from 'common/customIcons/inactive';
import InProgressIcon from 'common/customIcons/inprogress';
import OpenIcon from 'common/customIcons/open';
import PackedIcon from 'common/customIcons/packed';
import PendingApprovalIcon from "common/customIcons/pendingApproval";
import PendingFromDriverIcon from 'common/customIcons/pendingFromDriver';
import RejectedIcon from 'common/customIcons/rejected';
import ResolvedIcon from "common/customIcons/resolved";
import SplittingFinishedIcon from 'common/customIcons/splittingFinished';
import TickIcon from 'common/customIcons/tick';
import VerificationInProgressIcon from 'common/customIcons/verificationInProgress';
import VerifiedIcon from 'common/customIcons/verified';
import VerifyingInProgressIcon from 'common/customIcons/verifyingInProgress';
import React from 'react';

const statusObj = {
  active: <Box color='#24CA49' display='flex' alignItems='center'>
    <ActiveIcon width='18px' height='18px' flex='none' />
    <Typography variant='caption' fontWeight='regular' ml={.5} textTransform='capitalize'>Active</Typography>
  </Box>,
  inactive: <Box color='#FD4438' display='flex' alignItems='center'>
    <InActiveIcon width='18px' height='18px' flex='none' />
    <Typography variant='caption' fontWeight='regular' ml={.5} textTransform='capitalize'>Inactive</Typography>
  </Box>,  
  pending: <Box color='#8E0CF5' display='flex' alignItems='center'>
    <InProgressIcon width='18px' height='18px' flex='none' />
    <Typography variant='caption' fontWeight='regular' ml={.5} textTransform='capitalize'>Pending</Typography>
  </Box>, 
  splitting: <Box color='#FE7E07' display='flex' alignItems='center'>
    <SplittingFinishedIcon width='18px' height='18px' flex='none' />
    <Typography variant='caption' fontWeight='regular' ml={.5} textTransform='capitalize'>Splitting Finished</Typography>
  </Box>,
  distributed: <Box color='#24CA49' display='flex' alignItems='center'>
    <DistributedIcon width='18px' height='18px' flex='none' />
    <Typography variant='caption' fontWeight='regular' ml={.5} textTransform='capitalize'>Distributed</Typography>
  </Box>,
  freeze: <Box color='#8E0CF5' display='flex' alignItems='center'>
    <FreezedIcon width='18px' height='18px' flex='none' />
    <Typography variant='caption' fontWeight='regular' ml={.5} textTransform='capitalize'>Freezed</Typography>
  </Box>,
  dispatched: <Box color='#24CA49' display='flex' alignItems='center'>
    <DispatchedIcon width='18px' height='18px' flex='none' />
    <Typography variant='caption' fontWeight='regular' ml={.5} textTransform='capitalize'>Dispatched</Typography>
  </Box>,
  verified: <Box color='#24CA49' display='flex' alignItems='center'>
    <VerifiedIcon width='18px' height='18px' flex='none' />
    <Typography variant='caption' fontWeight='regular' ml={.5} textTransform='capitalize'>Verified</Typography>
  </Box>,
  "verifying in progress": <Box color='#A162F7' display='flex' alignItems='center'>
    <VerifyingInProgressIcon width='18px' height='18px' flex='none' />
    <Typography variant='caption' fontWeight='regular' ml={.5} textTransform='capitalize'>Verification In Progress</Typography>
  </Box>,
  "packed": <Box color='#FE7E07' display='flex' alignItems='center'>
    <PackedIcon width='18px' height='18px' flex='none' />
    <Typography variant='caption' fontWeight='regular' ml={.5} textTransform='capitalize'>Packed</Typography>
  </Box>,
  "open": <Box color='#FE7E07' display='flex' alignItems='center'>
    <OpenIcon width='18px' height='18px' flex='none' />
    <Typography variant='caption' fontWeight='regular' ml={.5} borderRadius={999} textTransform='capitalize'>Open</Typography>
  </Box>,
  "approved": <Box color='#24CA49' display='flex' alignItems='center'>
    <TickIcon width='18px' height='18px' flex='none' />
    <Typography variant='caption' fontWeight='regular' ml={.5} borderRadius={999} textTransform='capitalize'>Approved</Typography>
  </Box>,
  "rejected": <Box color='#FD4438' display='flex' alignItems='center'>
    <RejectedIcon width='18px' height='18px' flex='none' />
    <Typography variant='caption' fontWeight='regular' ml={.5} borderRadius={999} textTransform='capitalize'>Rejected</Typography>
  </Box>,
  "closure pending": <Box color='#A162F7' display='flex' alignItems='center'>
    <ClosurePendingIcon width='18px' height='18px' flex='none' />
    <Typography variant='caption' fontWeight='regular' ml={.5} borderRadius={999} textTransform='capitalize'>Closure Pending</Typography>
  </Box>,
  "pending from driver": <Box color='#FE7E07' display='flex' alignItems='center'>
    <PendingFromDriverIcon width='18px' height='18px' flex='none' />
    <Typography variant='caption' fontWeight='regular' ml={.5} borderRadius={999} textTransform='capitalize'>Pending From Driver</Typography>
  </Box>,
  "closed": <Box color='#24CA49' display='flex' alignItems='center'>
    <TickIcon width='18px' height='18px' flex='none' />
    <Typography variant='caption' fontWeight='regular' ml={.5} borderRadius={999} textTransform='capitalize'>Closed</Typography>
  </Box>,
  "verification in progress": <Box color='#A162F7' display='flex' alignItems='center'>
    <VerificationInProgressIcon width='18px' height='18px' flex='none' />
    <Typography variant='caption' fontWeight='regular' ml={.5} borderRadius={999} textTransform='capitalize'>Verification In Progress</Typography>
  </Box>,
  "verified and dispatched": <Box color='#24CA49' display='flex' alignItems='center'>
    <TickIcon width='18px' height='18px' flex='none' />
    <Typography variant='caption' fontWeight='regular' ml={.5} borderRadius={999} textTransform='capitalize'>Verified And Dispatched</Typography>
  </Box>,
  "on hold": <Box color='#656575' display='flex' alignItems='center'>
    <HoldIcon width='18px' height='18px' flex='none' />
    <Typography variant='caption' fontWeight='regular' ml={.5} borderRadius={999} textTransform='capitalize'>On Hold</Typography>
  </Box>,
  "completed": <Box color='#24CA49' display='flex' alignItems='center'>
    <CompletedIcon width='18px' height='18px' flex='none' />
    <Typography variant='caption' fontWeight='regular' ml={.5} borderRadius={999} textTransform='capitalize'>Completed</Typography>
  </Box>,
   pendingapproval: <Box color='#FE7E07' display='flex' alignItems='center'>
    <PendingApprovalIcon width='18px' height='18px' flex='none' />
    <Typography variant='caption' fontWeight='regular' ml={.5} textTransform='capitalize'>Pending Approval</Typography>
  </Box>, 
   resolved: <Box color='#24CA49' display='flex' alignItems='center'>
    <ResolvedIcon width='18px' height='18px' flex='none' />
    <Typography variant='caption' fontWeight='regular' ml={.5} textTransform='capitalize'>Resolved</Typography>
  </Box>, 
};

export default function StatusText({ status='' }) {
  
  return statusObj[status?.toLowerCase()]||<Box color='#FD4438' display='flex' alignItems='center'>
  <Typography variant='caption' fontWeight='regular' ml={.5} textTransform='capitalize'>{status}</Typography>
  </Box>;
}
// export default function StatusText({ status = '' }) {
  
//   // Ensure 'status' is a string before calling toLowerCase
//   const normalizedStatus = String(status).toLowerCase();

//   return statusObj[normalizedStatus] || null; // Return the corresponding icon or null if invalid
// }
